import {React, useState} from 'react'
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import axios from "axios";
import { API_URL } from '../../api-config';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    axios.post(`${API_URL}/users/forgot-password`, {
      email: email
    }, {
      headers: {
        "Content-Type": "application/json"
      }
    })

    .then(() => {
      toast.success('Se ha enviado un correo con las instrucciones para restaurar tu contraseña', {
        position: toast.POSITION.TOP_RIGHT
      });
    })

    .catch(error => {
      toast.success('Se ha enviado un correo con las instrucciones para restaurar tu contraseña', {
        position: toast.POSITION.TOP_RIGHT
      });
      console.log(error);
    });
  };

  return (
    <div>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }} id="qrt-icon">
            QRT
          </Avatar>
          <Typography component="h1" variant="h2">
            Actualización de contraseña
          </Typography>
          <br></br>
          <Typography component="h1" variant="h4">
            Te enviaremos un enlace a tu correo
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              variant='filled'
              label="Tu Email asociado"
              name="email"
              onChange={(e)=> setEmail(e.target.value)}
              autoComplete="email"
              autoFocus
            />
            <Typography component="h1" variant="h6" sx={{ mt: 1 }}>
              <Link href="/" sx={{ color: 'inherit', '&:hover': { color: 'blue', textDecoration: 'underline' } }}>
                Volver a la Ventana Principal
              </Link>
            </Typography>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              id="signup-button"
            >
              Enviar Enlace
            </Button>
          </Box>
        </Box>
      </Container>
    </div>
  )
}

export default ForgotPassword
